const SUFFIX_PATTERN = /^(.*?) \((\d+)\)$/;

/**
 * Bump a trailing " (n)" counter on a project name, or add " (2)" when there
 * isn't one yet. Used to de-duplicate indirect project names, which are shared
 * by many users and therefore collide on the org-unique name constraint.
 */
export const incrementNameSuffix = (name: string): string => {
  const match = name.match(SUFFIX_PATTERN);
  if (match) {
    return `${match[1]} (${Number(match[2]) + 1})`;
  }
  return `${name} (2)`;
};
